import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function InspectionPro() {
  const { t } = useTranslation('blogsignes');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  const navigateTo = (path: string) => {
    if (window.REACT_APP_NAVIGATE) window.REACT_APP_NAVIGATE(path);
  };

  return (
    <section ref={ref} id="inspection-pro" className="scroll-mt-28">
      <div
        className={`bg-slate-primary rounded-xl p-6 md:p-8 text-white transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        <div className="flex items-start gap-3 mb-5">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-copper shrink-0 mt-1">
            <i className="ri-search-line text-white text-lg" />
          </div>
          <h2 className="font-manrope font-bold text-xl md:text-2xl lg:text-3xl">
            {t('inspection_h2')}
          </h2>
        </div>

        <p className="text-white/80 text-base md:text-lg leading-relaxed mb-4">{t('inspection_p1')}</p>
        <p className="text-white/80 text-base md:text-lg leading-relaxed mb-8">{t('inspection_p2')}</p>

        <button
          onClick={() => navigateTo('/inspection-toiture')}
          className="group bg-copper hover:bg-copper/90 text-white font-bold px-8 py-4 rounded-md text-base md:text-lg transition-all duration-300 flex items-center gap-3 shadow-lg whitespace-nowrap"
        >
          {t('inspection_cta')}
          <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
        </button>
      </div>
    </section>
  );
}